export default __webpack_public_path__ + "static/media/Youtube.0a92f4b8.JPG";